import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ProductCard } from "@/components/ProductCard";
import { useProducts } from "@/hooks/useProducts";
import { useStore } from "@/store/StoreContext";

export default function Wishlist() {
  const { wishlist } = useStore();
  const { data: products = [] } = useProducts();
  const items = products.filter((p) => wishlist.includes(p.slug));

  return (
    <div className="mx-auto max-w-[1440px] px-5 py-16 md:px-10 lg:px-16 lg:py-24" data-testid="wishlist-page">
      <p className="label-eyebrow text-sand">Tersimpan</p>
      <h1 className="mt-5 font-display text-4xl leading-tight text-ink lg:text-5xl">Favorit</h1>
      <p className="mt-5 text-sm text-stone" data-testid="wishlist-note">
        Tersimpan di perangkat ini.
      </p>

      {items.length === 0 ? (
        <div className="mt-12 border-t border-line pt-12">
          <p className="text-base text-stone">Belum ada gelang yang kamu simpan.</p>
          <Link
            to="/koleksi"
            className="mt-8 inline-flex items-center gap-3 bg-ink px-9 py-4 text-[11px] uppercase tracking-[0.22em] text-paper transition-colors duration-300 hover:bg-espresso"
            data-testid="wishlist-shop-cta"
          >
            Jelajahi Koleksi <ArrowRight size={15} />
          </Link>
        </div>
      ) : (
        <div
          className="mt-14 grid grid-cols-2 gap-x-6 gap-y-16 border-t border-line pt-14 lg:grid-cols-4 lg:gap-x-8"
          data-testid="wishlist-grid"
        >
          {items.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
